import type { FaireProductEntity } from "../../entity_types/product";

export const p_q7f2bry674: FaireProductEntity = {
  token: "p_q7f2bry674",
  type: "product",
  name: "TT's Signature Toffee & Dark Chocolate Wafer Cookie",
  brandToken: "b_pxaznsy3qa",
  brandName: "Toffee Traditions",
  imageUrl:
    "https://cdn.faire.com/fastly/31942c1cd90a5c9880df0bc3c83a76ef6f7fc4e7fc23dd9c48f37f94301dd4ea.webp",
  galleryImageUrls: [],
  priceDollars: 2.42,
  description:
    "Savor the decadence of our Toffee &amp; Dark Chocolate Wafer Cookie. Each cookie is topped with a layer of crunchy, golden toffee baked right on top, giving it an irresistible caramelized finish. Inside, you'll find delicate wafers of rich dark chocolate that melt into the soft, chewy cookie base, creating the perfect balance of textures and flavors. The crisp toffee topping adds a delightful crunch with every bite, while the dark chocolate brings a deep, bittersweet contrast. Whether enjoyed on its own or paired with your favorite beverage, this cookie is a true indulgence for any toffee lover.",
  tags: [],
  msrpDollars: 4.85,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:16.178Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
